import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'; // need to install  http://redux.js.org/docs/basics/UsageWithReact.html
import { Button, Col, Row, Tabs, Tab } from 'react-bootstrap'; //It is like Boostrap  need to  install https://react-bootstrap.github.io
import { submitFormRequest } from './actions'; // import the actions
import { updateUserDetails, updateMealPlan } from '../../redux/actions/authenticationActions';
import MealPlanInfo from './MealPlanInfo';
import '../../public/css/MyAccount.css';
import { ToastContainer, ToastMessage } from '../../lib';
import { injectIntl, intlShape, FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import { getUserMealPlanSettings } from '../../api/api';
import PasswordStrengthInfo from '../auth/PasswordStrengthInfo';
import ListUserAddress from './ListUserAddress';
import { SOMETHING_WENT_WRONG } from '../../util/Constants';
import defaultMsg from '../../translations/lang/en-US.json';
import { validateEmail } from '../../util/validation';

const ToastMessageFactory = React.createFactory(ToastMessage.animation);

//creating a Component  using the class
class MyAccount extends React.Component {
  constructor(props) {
    super(props);
    const userDetails = get(props, 'loginUserDetails', {});
    // defined the react state
    this.state = {
      fname: userDetails.firstName || '',
      lname: userDetails.lastName || '',
      phonenumber: userDetails.mobile || '',
      Email: userDetails.email || '',
      address: '',
      state: '',
      city: '',
      zipcode: '',
      username: '',
      changePassword: '',
      newpassword: '',
      confirmPassword: '',
      checked: false,
      mealPlan: this.props.mealPlan,
      loadingMealPlanSetting: false,
      activeTab: this.getActiveTab(),
      wasInCheckout: false,
      disableClick: false,
    };

    // binding the functions with the this
    this.handleMyaccount = this.handleMyaccount.bind(this);
    this.firstNameOnchange = this.firstNameOnchange.bind(this);
    this.lastNameOnchange = this.lastNameOnchange.bind(this);
    this.phoneNumberOnchange = this.phoneNumberOnchange.bind(this);
    this.emailOnchange = this.emailOnchange.bind(this);
    this.addressOnchange = this.addressOnchange.bind(this);
    this.cityOnchange = this.cityOnchange.bind(this);
    this.stateOnchange = this.stateOnchange.bind(this);
    this.zipcodeOnchange = this.zipcodeOnchange.bind(this);
    this.usernameOnchange = this.usernameOnchange.bind(this);
    this.changePasswordOnchange = this.changePasswordOnchange.bind(this);
    this.newpasswordOnchange = this.newpasswordOnchange.bind(this);
    this.confirmPasswordOnchange = this.confirmPasswordOnchange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTabClick = this.handleTabClick.bind(this);
    this.onMealPlanSettingChange = this.onMealPlanSettingChange.bind(this);
    this.setTitle = this.setTitle.bind(this);
    this.primaryAddressDetails = this.primaryAddressDetails.bind(this);
    this.getActiveTab = this.getActiveTab.bind(this);
  }

  getActiveTab() {
    switch (this.props.params.mode) {
      case 'mealplan':
        return 2;
      default:
        return 1;
    }
  }

  componentWillMount() {
    this.setTitle();
  }

  setTitle() {
    document.title = `My Account - ${this.props.restaurantName} - Lavu To Go`;
  }

  primaryAddressDetails({
    address_1,
    address_2,
    state,
    city,
    zipcode,
    country,
  }) {
    this.setState({
      address: `${address_1} ${address_2}`,
      state,
      city,
      zipcode,
      country,
    });
  }

  handleTabClick(key) {
    if (key !== this.state.activeTab && !this.state.disableClick) {
      if (key === 2 && !this.state.loadingMealPlanSetting) {
        this.setState({ loadingMealPlanSetting: true }, () => {
          const { tokenId, jwt, loginUserDetails, dataname } = this.props;
          getUserMealPlanSettings({
            dataname,
            jwt,
            tokenId,
            user: loginUserDetails.id,
          }).then(apiResponse => {
            const userMealPlanSetting = get(
              apiResponse,
              'data.DataResponse',
              false
            );
            if (userMealPlanSetting !== false) {
              this.props.actions.updateMealPlan(userMealPlanSetting);
              this.setState({
                loadingMealPlanSetting: false,
                mealPlan: userMealPlanSetting,
                activeTab: key,
                wasInCheckout: false,
              });
            }
          });
        });
      } else {
        this.setState({ activeTab: key, wasInCheckout: true });
      }
    }
  }

  onMealPlanSettingChange(userMealPlanSetting) {
    this.setState({
      mealPlan: userMealPlanSetting,
    });
  }

  disableClick(status) {
    this.setState({
      disableClick: status,
    });
  }

  handleChange() {
    this.setState({
      checked: !this.state.checked,
    });
  }

  //Onchange handler  for the each input box
  firstNameOnchange(event) {
    this.setState({ fname: event.target.value });
  }

  lastNameOnchange(event) {
    this.setState({ lname: event.target.value });
  }

  phoneNumberOnchange(event) {
    this.setState({ phonenumber: event.target.value });
  }

  emailOnchange(event) {
    this.setState({ Email: event.target.value });
  }

  addressOnchange(event) {
    this.setState({ address: event.target.value });
  }

  cityOnchange(event) {
    this.setState({ city: event.target.value });
  }

  stateOnchange(event) {
    this.setState({ state: event.target.value });
  }

  zipcodeOnchange(event) {
    this.setState({ zipcode: event.target.value });
  }

  usernameOnchange(event) {
    this.setState({ username: event.target.value });
  }

  changePasswordOnchange(event) {
    this.setState({ changePassword: event.target.value });
  }

  newpasswordOnchange(event) {
    this.setState({ newpassword: event.target.value });
  }

  confirmPasswordOnchange(event) {
    this.setState({ confirmPassword: event.target.value });
  }

  onFormEnter() {
    return false;
  }

  handleMyaccount() {
    let firstName = this.state.fname;
    let lastName = this.state.lname;
    let phoneNumber = this.state.phonenumber;
    let Email = this.state.Email;
    let address = this.state.address;
    let city = this.state.city;
    let state = this.state.state;
    let zipcode = this.state.zipcode;
    let username = this.state.username;
    let changePassword = this.state.changePassword;
    let newPassword = this.state.newpassword;
    let confirmPassword = this.state.confirmPassword;

    // dispatch the function and send to an action.
    if (!validateEmail(Email)) {
      this.error(`Invalid email id provided : ${Email}`);
      return;
    }
    this.props.actions
      .submitFormRequest(
        firstName,
        lastName,
        phoneNumber,
        Email,
        address,
        city,
        state,
        zipcode,
        username,
        changePassword,
        newPassword,
        confirmPassword,
        this.props.loginUserDetails.id,
        this.props.tokenId,
        this.props.jwt
      )
      .then(resonse => {
        const {
          status = 'f',
          message = SOMETHING_WENT_WRONG,
          data = {},
        } = resonse;
        if (status.toLowerCase() === 's') {
          this.success(message);
          this.setState({
            checked: false,
            changePassword: '',
            newpassword: '',
            confirmPassword: '',
          });
          if (Object.keys(data).length) {
            this.props.actions.updateUserDetails(data);
          }
        } else {
          this.error(message);
        }
      });
  }

  error(msg) {
    this.refs.myaccont_container.error(msg);
  }

  success(msg) {
    this.refs.myaccont_container.success(msg);
  }

  render() {
    const hidden = this.state.checked ? '' : 'hidden';

    return (
      <div className="flex">
        <ToastContainer
          toastMessageFactory={ToastMessageFactory}
          ref="myaccont_container"
          className="toast-top-right"
        />
        <div className="cont-style">
          <Tabs
            defaultActiveKey={this.state.activeTab}
            animation={true}
            id="user-account-setting-panel"
            onSelect={this.handleTabClick}
            className="more-space"
          >
            <Tab
              eventKey={1}
              title={this.props.intl.formatMessage({
                id: 'tabAccountSettings',
                defaultMessage: defaultMsg.tabAccountSettings,
              })}
            >
              <Row className="page-title">
                <Col md={12}>
                  <h4>
                    <FormattedMessage
                      id="myAccount"
                      defaultMessage={defaultMsg.myAccount}
                    />
                    <span className="font-small pull-right">
                      <mark className="mark-style"> *</mark>
                      <FormattedMessage
                        id="denotesRequiredField"
                        defaultMessage={defaultMsg.denotesRequiredField}
                      />
                    </span>
                  </h4>
                </Col>
              </Row>
              <form onSubmit={this.onFormEnter}>
                <Row className="page-content">
                  <div className="col-xs-12 col-md-6">
                    <h4>
                      <b>
                        <FormattedMessage
                          id="personalInformation"
                          defaultMessage={defaultMsg.personalInformation}
                        />
                      </b>
                    </h4>
                    <br />
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label htmlFor="Name">
                            <FormattedMessage
                              id="firstName"
                              defaultMessage={defaultMsg.firstName}
                            />
                            <mark className="mark-style"> * </mark>
                          </label>
                          <input
                            type="name"
                            className="form-control"
                            id="fname"
                            placeholder={this.props.intl.formatMessage({
                              id: 'placeholderEnterFirstName',
                              defaultMessage:
                                defaultMsg.placeholderEnterFirstName,
                            })}
                            onChange={this.firstNameOnchange}
                            required
                            value={this.state.fname}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label htmlFor="Name">
                            <FormattedMessage
                              id="lastName"
                              defaultMessage={defaultMsg.lastName}
                            />
                            <mark className="mark-style"> * </mark>
                          </label>
                          <input
                            type="name"
                            className="form-control"
                            id="lname"
                            placeholder={this.props.intl.formatMessage({
                              id: 'placeholderEnterLastName',
                              defaultMessage:
                                defaultMsg.placeholderEnterLastName,
                            })}
                            onChange={this.lastNameOnchange}
                            required
                            value={this.state.lname}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label htmlFor="Phone">
                            <FormattedMessage
                              id="telephoneNumber"
                              defaultMessage={defaultMsg.telephoneNumber}
                            />
                            <mark className="mark-style"> * </mark>
                          </label>
                          <input
                            type="tel"
                            className="form-control"
                            id="phonenumber"
                            placeholder={this.props.intl.formatMessage({
                              id: 'placeholderEnterTelephoneNumber',
                              defaultMessage:
                                defaultMsg.placeholderEnterTelephoneNumber,
                            })}
                            onChange={this.phoneNumberOnchange}
                            required
                            value={this.state.phonenumber}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label htmlFor="Email1">
                            <FormattedMessage
                              id="emailAddress"
                              defaultMessage={defaultMsg.emailAddress}
                            />
                            <mark className="mark-style"> * </mark>
                          </label>
                          <input
                            type="email"
                            className="form-control"
                            id="Email"
                            placeholder={this.props.intl.formatMessage({
                              id: 'placeholderEnterEmailAddress',
                              defaultMessage:
                                defaultMsg.placeholderEnterEmailAddress,
                            })}
                            onChange={this.emailOnchange}
                            required
                            value={this.state.Email}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xs-12 col-md-6 ">
                    <h4>
                      <b>
                        <FormattedMessage
                          id="accountPreferences"
                          defaultMessage={defaultMsg.accountPreferences}
                        />
                      </b>
                      <div
                        className="checkbox pull-right"
                        style={{ margin: '0px' }}
                      >
                        <label>
                          <input
                            type="checkbox"
                            checked={this.state.checked}
                            onChange={this.handleChange}
                            style={{ marginTop: '2.5px', marginLeft: '-20px' }}
                          />
                          <span className="font-small">
                            <FormattedMessage
                              id="changeAccountPreferences"
                              defaultMessage={
                                defaultMsg.changeAccountPreferences
                              }
                            />
                            <label />
                          </span>
                        </label>
                      </div>
                    </h4>
                    <br />
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label htmlFor="password">
                            <FormattedMessage
                              id="verifyCurrentPassword"
                              defaultMessage={defaultMsg.verifyCurrentPassword}
                            />
                            <mark className="mark-style"> * </mark>
                          </label>
                          <input
                            className="form-control"
                            id="changePassword"
                            onChange={this.changePasswordOnchange}
                            type="password"
                            placeholder={this.props.intl.formatMessage({
                              id: 'placeholderVerifyCurrentPassword',
                              defaultMessage:
                                defaultMsg.placeholderVerifyCurrentPassword,
                            })}
                            required
                            disabled={hidden}
                            value={this.state.changePassword}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label htmlFor="Newpassword">
                            <FormattedMessage
                              id="enterNewPassword"
                              defaultMessage={defaultMsg.enterNewPassword}
                            />
                            <mark className="mark-style"> * </mark>
                          </label>
                          <input
                            className="form-control"
                            id="newpassword"
                            onChange={this.newpasswordOnchange}
                            type="password"
                            placeholder={this.props.intl.formatMessage({
                              id: 'placeholderEnterNewPassword',
                              defaultMessage:
                                defaultMsg.placeholderEnterNewPassword,
                            })}
                            required
                            disabled={hidden}
                            value={this.state.newpassword}
                          />
                          <PasswordStrengthInfo />
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="form-group">
                          <label htmlFor="confirmPassword">
                            <FormattedMessage
                              id="confirmNewPassword"
                              defaultMessage={defaultMsg.confirmNewPassword}
                            />
                            <mark className="mark-style"> * </mark>
                          </label>
                          <input
                            className="form-control"
                            id="confirmPassword"
                            onChange={this.confirmPasswordOnchange}
                            type="password"
                            placeholder={this.props.intl.formatMessage({
                              id: 'placeholderConfirmNewPassword',
                              defaultMessage:
                                defaultMsg.placeholderConfirmNewPassword,
                            })}
                            required
                            disabled={hidden}
                            value={this.state.confirmPassword}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="col-lg-12 col-md-12 col-sm-12 col-xs-12"
                    style={{ marginTop: '20px' }}
                  >
                    <Button
                      type="button"
                      className="btn btn-success olo-client-theme-color-white olo-client-theme-background"
                      onClick={this.handleMyaccount}
                    >
                      <FormattedMessage
                        id="saveChanges"
                        defaultMessage={defaultMsg.saveChanges}
                      />
                    </Button>
                  </div>
                  <ListUserAddress
                    alert={this.refs.myaccont_container}
                    recievePrimaryAddress={data =>
                      this.primaryAddressDetails(data || {})
                    }
                  />
                </Row>
              </form>
            </Tab>

            {this.props.mealPlan &&
            this.props.mealPlan.mealPlanEnable === 'true' ? (
              <Tab
                eventKey={2}
                title={this.props.intl.formatMessage({
                  id: 'tabMealPlanSettings',
                  defaultMessage: defaultMsg.tabMealPlanSettings,
                })}
              >
                <MealPlanInfo
                  mealPlan={this.state.mealPlan}
                  loadingMealPlanSetting={this.state.loadingMealPlanSetting}
                  wasInCheckout={this.state.wasInCheckout}
                  disableClick={status => this.disableClick(status)}
                  onMealPlanSettingChange={settings =>
                    this.onMealPlanSettingChange(settings)
                  }
                  addFunds={
                    this.props.params.addFunds ? this.props.params.addFunds : ''
                  }
                  rname={this.props.params.rname}
                />
              </Tab>
            ) : null}
          </Tabs>
        </div>
      </div>
    );
  }
}

// convert  state to props  fetch from the state from store
function mapStateToProps(state) {
  return {
    errorMessage: state.myaccount.error,
    message: state.myaccount.message,
    loginUserDetails: state.auth.loginUserDetails,
    tokenId: state.auth.tokenId,
    jwt: state.auth.jwt,
    mealPlan: get(state, 'auth.loginUserDetails.mealplan', false),
    dataname: state.dashboard.dataName,
    restaurantName: state.dashboard.merchantDetails.title,
  };
}
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateMealPlan,
      submitFormRequest,
      updateUserDetails,
    },
    dispatch
  ),
});

MyAccount.propTypes = {
  intl: intlShape.isRequired,
};

// connecting to redux
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(MyAccount));



// WEBPACK FOOTER //
// ./src/views/myaccount/MyAccount.jsx